// extracted by mini-css-extract-plugin
export default {"BuildingSelect":"BuildingSelect_BuildingSelect__LhtsU","BuildingSelectWhite":"BuildingSelect_BuildingSelectWhite__DX78Q"};